import { render, staticRenderFns } from "./reportesTorre.vue?vue&type=template&id=919a208a&scoped=true&"
import script from "./reportesTorre.vue?vue&type=script&lang=ts&"
export * from "./reportesTorre.vue?vue&type=script&lang=ts&"
import style0 from "./reportesTorre.vue?vue&type=style&index=0&id=919a208a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "919a208a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('919a208a', component.options)
    } else {
      api.reload('919a208a', component.options)
    }
    module.hot.accept("./reportesTorre.vue?vue&type=template&id=919a208a&scoped=true&", function () {
      api.rerender('919a208a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/reportes/reportesTorre.vue"
export default component.exports